import type { TOC } from '@ember/component/template-only';
import { concat } from '@ember/helper';
import type { BufferedChangeset } from 'ember-changeset/types';
import t from 'ember-intl/helpers/t';
import GenericField from 'parog-web/components/bio-exam-results/edition-form/generic-field';
import type Patient from 'parog-web/models/patient';
import fuiAccordion from 'wise-fui-modules/modifiers/fui-accordion';
import type { ExamsByGroup } from '../utils/groupedBioExams';
interface Signature {
  Args: {
    changeset: BufferedChangeset;
    groupedBioExamsObs?: ExamsByGroup;
    patient: Patient;
  };
}

const ResultsSection: TOC<Signature> = <template>
  {{#each-in @groupedBioExamsObs as |groupName obsByLoincChapters|}}
    <h2 class='ui header'>
      {{t (concat 'bioExamResults.' groupName)}}
    </h2>
    {{#each-in obsByLoincChapters as |loincChapterName bioExamObservations|}}
      <div {{fuiAccordion}} class='ui accordion fluid visible'>
        <div class='ui header title active'>
          <h3>
            <i class='dropdown icon'></i>
            {{loincChapterName}}
          </h3>
        </div>

        <div class='content active'>
          {{#each bioExamObservations as |bioExamObservation|}}
            <div class='field last:!mb-[1.5em]'>
              <GenericField
                @patient={{@patient}}
                @changeset={{@changeset}}
                {{! @glint-expect-error bioExamObservation is a BioExam that is a BioExamObservation or a BioExamOrder }}
                @bioExamObservation={{bioExamObservation}}
              />
            </div>
          {{/each}}
        </div>
      </div>
    {{/each-in}}
  {{/each-in}}
</template>;

export default ResultsSection;
